import { checkout_ending } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/logic/actions.js?1733898722633';
import { customer_logout_action } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/logic/customer_logout_action.js?1733898722633';

export function customer_logout(customer_logged_out = false) {
    checkout_ending().finally(() => {
        customer_logout_action(customer_logged_out);
    }); // async
}
